module.exports = __webpack_public_path__ + "img/Professional.70076add.svg";